<comp-dialog>
  <ng-container comp-dialog-header-title>{{ 'products.add' | translate }}</ng-container>

  <ng-container comp-dialog-content>
    @if (supportedIntakeTypes(); as intakeTypes) {
      <form id="add-product-form" [formRoot]="productForm">
        <mat-form-field
          appearance="outline"
          [floatLabel]="'always'"
          class="ul-single-line-input outlined-form-element"
        >
          <mat-label>{{ 'model.product.properties.name' | translate }}</mat-label>
          <input
            compAutofocus
            [formField]="productForm.name"
            matInput
            (input)="clearUniquenessError('name')"
            (blur)="validateUniqueness('PRODUCT')"
          />
          @if (uniquenessErrors().name) {
            <mat-error>{{ 'general.validation.uniqueness' | translate }}</mat-error>
          }
          @if (productForm.name().getError('required')) {
            <mat-error>{{ 'general.validation.required' | translate }}</mat-error>
          }
          @if (productForm.name().getError('maxlength')) {
            <mat-error>{{'general.validation.maxlength' | translate: { length: 255 } </mat-error>
          }
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          [floatLabel]="'always'"
          class="ul-textarea-field outlined-form-element"
        >
          <mat-label>{{ 'model.product.properties.description' | translate }}</mat-label>
          <textarea
            placeholder="Please describe the purpose and usage intent of the product and list the major components."
            [formField]="productForm.description"
            matInput
          ></textarea>
        </mat-form-field>

        <p class="ul-form-field">
          <mat-checkbox [formField]="productForm.createRevision">{{
            'products.create.createRevision' | translate
          }}</mat-checkbox>
        </p>

        <div class="revision-form" [class.expanded]="showRevisionForm()">
          <div class="revision-form-inner">
            <mat-form-field
              appearance="outline"
              [floatLabel]="'always'"
              class="ul-single-line-input outlined-form-element"
            >
              <mat-label>{{ 'products.create.revisionName' | translate }}</mat-label>
              <input
                [formField]="productForm.revisionName"
                matInput
                (input)="clearUniquenessError('revisionName')"
                (blur)="validateUniqueness('REVISION')"
              />
              @if (uniquenessErrors().revisionName) {
                <mat-error>{{ 'general.validation.uniqueness' | translate }}</mat-error>
              }
              @if (productForm.revisionName().getError('required')) {
                <mat-error> {{ 'general.validation.required' | translate }} </mat-error>
              }
              @if (productForm.revisionName().getError('maxlength')) {
                <mat-error
                  >{{
                    'general.validation.maxlength'
                      | translate
                        : {
                            length: 255,
                          }
                  }}
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline" class="ul-single-line-input outlined-form-element">
              <mat-label>{{ 'model.productRevision.properties.intakeType' | translate }}</mat-label>
              <mat-select panelWidth="auto" [formField]="productForm.intakeType">
                @for (intakeType of intakeTypes.values(); track intakeType.ident) {
                  <mat-option [value]="intakeType.ident" [title]="intakeType.description">
                    {{ intakeType.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
            @let selectedIntakeTypeDescription =
              intakeTypes.get(productFormModel().intakeType)?.description;
            @if (selectedIntakeTypeDescription !== undefined) {
              <p class="form-field-help-text">
                {{ selectedIntakeTypeDescription }}
              </p>
            }
            @if (!productForm.openRevision().disabled()) {
              <mat-checkbox [formField]="productForm.openRevision">{{
                'revisions.open' | translate
              }}</mat-checkbox>
            }
          </div>
        </div>
      </form>
    } @else {
      <comp-progress-spinner [errorMessageKey]="errorMessageKey()">{{
        'intake.typesLoading.message' | translate
      }}</comp-progress-spinner>
    }
  </ng-container>
  <ng-container comp-dialog-footer>
    <comp-card-buttons>
      <ng-container ngProjectAs="[right]">
        <button type="button" comp-button="secondary" (click)="onCancel()">
          {{ 'general.cancel' | translate }}
        </button>
        <button comp-button action="save" type="submit" form="add-product-form">
          {{ 'general.save' | translate }}
        </button>
      </ng-container>
    </comp-card-buttons>
  </ng-container>
</comp-dialog>
